<div class="container-fluid page">
  <div class="d-flex page__box p-3 mt-3 header">
    <span class="material-icons">book</span> Business Term
  </div>
  <mat-horizontal-stepper #stepper>
    <mat-step [stepControl]="requiredStepForm">
      <ng-template matStepLabel>
        <i class="fa fa-check-circle"></i> Required
      </ng-template>
      <div class="stepper-container">
        <mat-card class="example-card">
          <form [formGroup]="requiredStepForm" class="form-container">
            <div class="input-container">
              <mat-form-field class="input">
                <input matInput placeholder="{{dataObj['di_tech_nm']['name']}}" formControlName="di_tech_nm">
                <mat-icon *ngIf="dataObj['di_tech_nm']['description']" matSuffix color="primary"
                  matTooltip="{{dataObj['di_tech_nm']['description']}}">
                  info
                </mat-icon>
                <mat-error *ngIf="requiredStepForm.get('di_tech_nm').hasError('required')">required</mat-error>
              </mat-form-field>
            </div>
            <div class="input-container">
              <mat-form-field class="input">
                <input matInput placeholder="{{dataObj['di_bus_nm']['name']}}" formControlName="di_bus_nm">
                <mat-icon *ngIf="dataObj['di_bus_nm']['description']" matSuffix color="primary"
                  matTooltip="{{dataObj['di_bus_nm']['description']}}">
                  info
                </mat-icon>
                <mat-error *ngIf="requiredStepForm.get('di_bus_nm').hasError('required')">required</mat-error>
              </mat-form-field>
            </div>
            <div class="input-container">
              <mat-form-field class="input">
                <input matInput placeholder="{{dataObj['di_desc']['name']}}" formControlName="di_desc">
                <mat-icon *ngIf="dataObj['di_desc']['description']" matSuffix color="primary"
                  matTooltip="{{dataObj['di_desc']['description']}}">
                  info
                </mat-icon>

              </mat-form-field>
            </div>

          </form>
        </mat-card>
      </div>
      <div class="button-container">
        <button mat-button matStepperPrevious color="warn" (click)="backtolist()">Cancel</button>
        <button mat-button color="primary" (click)="submit()" *ngIf="rrvconfig['mode']=='create'">Save</button>
        <button mat-button color="accent" (click)="gotoAdditonal(stepper)">Next</button>
      </div>
      <div>
      </div>
    </mat-step>
    <mat-step [stepControl]="requiredStepForm">
      <ng-template matStepLabel>
        <i class="fa fa-cogs"></i> Additional Details
      </ng-template>
      <form [formGroup]="requiredStepForm" class="form-container">
        <mat-horizontal-stepper #innerStepper>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-file"></i> Datatype Details</ng-template>

            <div class="stepper-container">
              <mat-card class="example-card1">
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-select placeholder="{{dataObj['dt_tcd']['name']}}" formControlName="dt_tcd">
                      <mat-option *ngFor="let item of datatype" [value]="item">{{item}}</mat-option>
                    </mat-select>
                    <mat-icon *ngIf="dataObj['dt_tcd']['description']" matSuffix color="primary"
                      matTooltip="{{dataObj['dt_tcd']['description']}}">
                      info
                    </mat-icon>
                    <mat-error *ngIf="requiredStepForm.get('dt_tcd').hasError('required')">required</mat-error>
                  </mat-form-field>
                </div>
                <div class="contentmain" *ngIf="requiredStepForm.get('dt_tcd').value === 'STRING'">

                  <div formGroupName="di_tcd_json">
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-label>Term Minimum Length</mat-label>
                        <input matInput type="number" class="example-right-align" placeholder=""
                          formControlName="minLength">
                        <mat-icon *ngIf="dataObj['minLength']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['minLength']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>

                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-label>Term Maximum Length</mat-label>
                        <input matInput type="number" class="example-right-align" placeholder=""
                          formControlName="maxLength">
                        <mat-icon *ngIf="dataObj['maxLength']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['maxLength']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-label>Term Pattern</mat-label>
                        <!-- <input matInput type="text" class="example-right-align" placeholder="" rows="5"> -->
                        <input matInput type="text" class="example-right-align" placeholder=""
                          formControlName="pattern">
                        <mat-icon *ngIf="dataObj['pattern']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['pattern']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>

                    </div>
                    <div class="input-container">
                      <mat-radio-group label="Select an option" formControlName="nullable" class="input">
                        <span class="font" style="margin-left:0px ;">Nullable?</span>
                        <mat-radio-button [value]="true">Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
                <div class="contentmain"
                  *ngIf="requiredStepForm.get('dt_tcd').value === 'INTEGER' || requiredStepForm.get('dt_tcd').value === 'DECIMAL'">

                  <div formGroupName="di_tcd_json">
                    <div class="row-container" *ngIf="requiredStepForm.get('dt_tcd').value === 'DECIMAL'">
                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Enter Precision</mat-label>
                          <input matInput type="number" class="example-right-align" placeholder=""
                            formControlName="precision">
                          <mat-icon class="icon" matSuffix>
                            edit
                          </mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Enter Scale</mat-label>
                          <input matInput type="number" class="example-right-align" placeholder=""
                            formControlName="scale">
                          <mat-icon class="icon" matSuffix>
                            edit
                          </mat-icon>
                        </mat-form-field>
                      </div>

                    </div>
                    <!-- Additional common fields can be added here -->
                    <div class="row-container">

                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Signed?</mat-label>
                          <mat-select placeholder="" class="font" formControlName="signed">
                            <mat-option *ngFor="let item of boolarr" [value]="item">{{item}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Zerofilled?</mat-label>
                          <mat-select placeholder="" class="font" formControlName="zerofilled">
                            <mat-option *ngFor="let item of boolarr" [value]="item">{{item}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row-container" *ngIf="requiredStepForm.get('dt_tcd').value === 'DECIMAL'">
                      <!-- Fields specific to 'decimal' type -->
                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Select Rounding Type</mat-label>
                          <mat-select placeholder="" class="font" formControlName="rounding_method">
                            <mat-option *ngFor="let item of roundtypearr" [value]="item?.code">{{item?.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Exact?</mat-label>
                          <mat-select placeholder="" class="font" formControlName="exact">
                            <mat-option *ngFor="let item of boolarr" [value]="item">{{item}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>


                    <div class="row-container" *ngIf="requiredStepForm.get('dt_tcd').value === 'INTEGER'">

                      <div class="col-container">
                        <mat-form-field class="input">
                          <mat-label>Enter Precision</mat-label>
                          <input matInput type="number" class="example-right-align" placeholder=""
                            formControlName="precision">
                          <mat-icon class="icon" matSuffix>
                            edit
                          </mat-icon>
                        </mat-form-field>
                      </div>
                      <div class="col-container">
                        <mat-radio-group label="Select an option" formControlName="nullable">
                          <span class="font" style="margin-left:0px ;">Nullable?</span>
                          <mat-radio-button [value]="true">Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <mat-radio-button [value]="false">No</mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <div class="input-container" *ngIf="requiredStepForm.get('dt_tcd').value === 'DECIMAL'">
                      <mat-radio-group label="Select an option" formControlName="nullable">
                        <span class="font" style="margin-left:0px ;">Nullable?</span>
                        <mat-radio-button [value]="true">Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <mat-radio-button [value]="false">No</mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                </div>
                <div class="contentmain">
                  <div class="input-container" formGroupName="di_tcd_json">
                    <mat-form-field
                      *ngIf="requiredStepForm.get('dt_tcd').value === 'DATETIME' || requiredStepForm.get('dt_tcd').value === 'TIME'"
                      class="input">
                      <mat-label>Enter Second Precision</mat-label>
                      <input matInput type="number" class="example-right-align" placeholder=""
                        formControlName="sec_fraction">
                      <mat-icon class="icon" matSuffix>edit</mat-icon>
                    </mat-form-field>

                  </div>
                  <div class="input-container" formGroupName="di_tcd_json"
                    *ngIf="requiredStepForm.get('dt_tcd').value === 'DATETIME' || requiredStepForm.get('dt_tcd').value === 'TIME' || requiredStepForm.get('dt_tcd').value === 'DATE' || requiredStepForm.get('dt_tcd').value === 'BOOLEAN'">
                    <mat-radio-group label="Select an option" style="margin-top:10px ;" formControlName="nullable">
                      <span class="font" style="margin-left:0px ;">Nullable?</span>
                      <mat-radio-button [value]="true">Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div class="contentmain" *ngIf="requiredStepForm.get('dt_tcd').value === 'JSON'">

                  <div class="input-container">
                    <mat-form-field class="input">
                      <mat-label>Schema Composition</mat-label>
                      <mat-select [(ngModel)]="schemacompostiontype" [ngModelOptions]="{standalone: true}"
                        (selectionChange)="compositionchange($event.value)">
                        <mat-option *ngFor="let option of schemaCompositionOptions" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="row-container">

                    <div class="left-content"></div>
                    <mat-icon class="right-content" style="color:rgb(0, 140, 255)" (click)="addSchema()"
                      *ngIf="schemacompostiontype=='oneOf' || schemacompostiontype=='anyOf' || schemacompostiontype=='allOf' ">
                      add_box
                    </mat-icon>

                  </div>
                  <div class="example-container" *ngIf="schemacompostiontype">
                    <div *ngFor="let schema of schemas; let i = index" class="custom-panel-above">
                      <mat-card class="card1">
                        <div class="row-container">
                          <h5 class="font" style="font-weight:bold ;"> <span
                              class="material-icons">library_add</span>Schema Definition</h5>

                          <mat-icon class="right-content" style="color:red" (click)="deleteschema(i)"
                            *ngIf="schemacompostiontype=='oneOf' || schemacompostiontype=='anyOf' || schemacompostiontype=='allOf' ">
                            delete</mat-icon>
                        </div>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="heading-with-icon font">
                              <span class="material-icons">folder</span> Annotations
                            </mat-panel-title>

                          </mat-expansion-panel-header>
                          <div>
                            <div class="row-container">
                              <div class="left-content"></div>
                              <mat-icon class="right-content" style="color:rgb(0, 140, 255)"
                                (click)="onAddAnnotation(i)">
                                add_box</mat-icon>
                            </div>

                            <table class="table table-bordered" style="width: 90%; margin-left: 5%;">
                              <thead>
                                <tr class="Table-header">
                                  <td>Annotation Type</td>
                                  <td>Value</td>
                                  <td>Action</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let annotation of schema.annotations; let j = index">
                                  <td>
                                    <!-- <select [(ngModel)]="annotation.type" name="annotationType{{i}}-{{j}}" class="font">
                                    <option value="title">Title</option>
                                    <option value="description">Description</option>
                                    <option value="default">Default</option>
                                    <option value="example">Example</option>
                                  </select> -->


                                    <mat-form-field>
                                      <mat-label>Select type</mat-label>
                                      <mat-select placeholder="select" class="font" [(ngModel)]="annotation.type"
                                        [ngModelOptions]="{standalone: true}">
                                        <mat-option *ngFor="let item of annotationsarr" [value]="item">{{item}}
                                        </mat-option>
                                      </mat-select>
                                    </mat-form-field>
                                  </td>
                                  <td>
                                    <!-- <input type="text" [(ngModel)]="annotation.value" name="annotationValue{{i}}-{{j}}"
                                    class="font"> -->

                                    <mat-form-field>
                                      <mat-label>Annotation Value</mat-label>
                                      <input matInput type="text" class="example-right-align" placeholder=""
                                        [(ngModel)]="annotation.value" [ngModelOptions]="{standalone: true}">
                                      <mat-icon class="icon" matSuffix>
                                        edit
                                      </mat-icon>
                                    </mat-form-field>
                                  </td>
                                  <td>
                                    <!-- <button  class="light">Delete</button> -->
                                    <mat-icon style="color:red" (click)="onDeleteAnnotation(i, j)">delete</mat-icon>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <!-- <button (click)="onAddAnnotation(i)" class="light">Add Annotation</button> -->
                            <!-- <button (click)="submitAnnotations(i)" class="blue">Submit Annotations</button> -->
                          </div>
                        </mat-expansion-panel>

                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title class="heading-with-icon font">
                              <span class="material-icons">folder</span> Properties
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div>
                            <mat-form-field>
                              <mat-label>Select Property</mat-label>
                              <mat-select (selectionChange)="addTermToProperties($event.value, i)" class="font">
                                <mat-option *ngFor="let term of termarr" [value]="term">
                                  {{ term.di_tech_nm }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                            <!-- Table for term properties -->
                            <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                           
                              <thead>
                                <tr class="Table-header">
                                  <td>Title</td>
                                  <td>Description</td>
                                  <!-- <td>Properties</td> -->
                                  <td>Is Required</td>
                                  <td>Action</td>
                                </tr>
                              </thead>
                              <!-- Table body -->
                              <tbody>
                                <tr *ngFor="let property of schema.termProperties ;let k = index">
                                  <td class="font1">{{ property.title }}</td>
                                  <td class="font1">{{ property.description }}</td>
                                  <!-- <td>
                                 
                                    <mat-icon style="color:rgb(43, 114, 51)" (click)="showProperties(property)">
                                      visibility
                                    </mat-icon>
                                  </td> -->
                                  <td>
                                    <input type="checkbox" [checked]="property?.properties?.required"
                                      (change)="onCheckboxChange(i,k)" class="font">
                                  </td>
                                  <td>
                                    <mat-icon style="color:red" (click)="removeTerm(i,k)">delete</mat-icon>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </mat-expansion-panel>
                      </mat-card>


                    </div>


                  </div>

                  <div class="input-container" formGroupName="di_tcd_json">
                    <mat-radio-group label="Select an option" formControlName="nullable">
                      <span class="font" style="margin-left:0px ;">Nullable?</span>
                      <mat-radio-button [value]="true">Yes</mat-radio-button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <mat-radio-button [value]="false">No</mat-radio-button>
                    </mat-radio-group>
                  </div>

                  <div class="json-container">

                    <pre><code id="json-content"></code></pre>
                  </div>
                </div>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button color="warn" (click)="goBackToFirstStepper()">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-tags"></i> Classifications</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-label>Has Classifications?</mat-label>
                    <mat-select placeholder="" class="font" formControlName="hasClassifications">
                      <mat-option *ngFor="let item of yesnoarr" [value]="item.code">{{item.value}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div *ngIf="requiredStepForm.get('hasClassifications').value">

                  <div class="input-container">
                    <mat-form-field class="input" formGroupName="di_tcd_json">
                      <mat-label>Classification Type</mat-label>
                      <mat-select placeholder="" class="font" formControlName="av_tcd">
                        <mat-option *ngFor="let item of codevaluetcd" [value]="item.code">{{item.value}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
                <!-- <div *ngIf="requiredStepForm.get('di_tcd_json.av_tcd')?.value === 'SV'">
                <div class="row-container">
                  <div class="left-content"></div>
                  <mat-icon class="right-content" style="color:rgb(0, 140, 255)" (click)="onAddClassification()">
                    add_box
                  </mat-icon>
                </div>
                
                <table class="table table-bordered" style="width: 90%; margin-left: 5%;">
                  <thead>
                    <tr class="Table-header">
                      <td>Code</td>
                      <td>Value</td>
                      <td>Action</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let classification of clarr; let j = index">
                      <td>
                        <mat-form-field>
                          <mat-label>Classification Code</mat-label>
                          <input matInput type="text" class="example-right-align" placeholder="" [(ngModel)]="classification.cl_cd" 
                          [ngModelOptions]="{standalone: true}" width="100%">
                       
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field>
                          <mat-label>Classification Value</mat-label>
                          <input matInput type="text" class="example-right-align" placeholder="" [(ngModel)]="classification.cl_val" 
                            [ngModelOptions]="{standalone: true}">
                        
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-icon style="color:red" (click)="onDeleteClassification(j)">delete</mat-icon>
                      </td>
                    </tr>
                  </tbody>
                </table>
                </div> -->
                



                <div *ngIf="requiredStepForm.get('di_tcd_json.av_tcd')?.value === 'MV'">
                  <div *ngFor="let schema of schemasmv; let i = index" class="custom-panel-above">
                    <mat-card class="card1">

                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title class="heading-with-icon font">
                            <span class="material-icons">folder</span> Annotations
                          </mat-panel-title>

                        </mat-expansion-panel-header>
                        <div>
                          <div class="row-container">
                            <div class="left-content"></div>
                            <mat-icon class="right-content" style="color:rgb(0, 140, 255)"
                              (click)="onAddAnnotationmv(i)">
                              add_box</mat-icon>
                          </div>

                          <table class="table table-bordered" style="width: 90%; margin-left: 5%;">
                            <thead>
                              <tr class="Table-header">
                                <td>Annotation Type</td>
                                <td>Value</td>
                                <td>Action</td>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let annotation of schema.annotations; let j = index">
                                <td>
                                  <mat-form-field>
                                    <mat-label>Select type</mat-label>
                                    <mat-select placeholder="select" class="font" [(ngModel)]="annotation.type"
                                      [ngModelOptions]="{standalone: true}">
                                      <mat-option *ngFor="let item of annotationsarr" [value]="item">{{item}}
                                      </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                </td>
                                <td>
                                  <!-- <input type="text" [(ngModel)]="annotation.value" name="annotationValue{{i}}-{{j}}"
                                class="font"> -->

                                  <mat-form-field>
                                    <mat-label>Annotation Value</mat-label>
                                    <input matInput type="text" class="example-right-align" placeholder=""
                                      [(ngModel)]="annotation.value" [ngModelOptions]="{standalone: true}">
                                    <mat-icon class="icon" matSuffix>
                                      edit
                                    </mat-icon>
                                  </mat-form-field>
                                </td>
                                <td>
                                  <!-- <button  class="light">Delete</button> -->
                                  <mat-icon style="color:red" (click)="onDeleteAnnotationmv(i, j)">delete</mat-icon>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <button (click)="onAddAnnotation(i)" class="light">Add Annotation</button> -->
                          <!-- <button (click)="submitAnnotations(i)" class="blue">Submit Annotations</button> -->
                        </div>
                      </mat-expansion-panel>

                      <mat-expansion-panel>
                        <mat-expansion-panel-header>
                          <mat-panel-title class="heading-with-icon font">
                            <span class="material-icons">folder</span> Properties
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div>
                          <mat-form-field>
                            <mat-label>Select Property</mat-label>
                            <mat-select (selectionChange)="addTermToPropertiesmv($event.value, i)" class="font">
                              <mat-option *ngFor="let term of termarr" [value]="term">
                                {{ term.di_tech_nm }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                        
                          <table class="table table-bordered" style="width: 90%; margin-left: 5%;font-size: smaller;">
                        
                            <thead>
                              <tr class="Table-header">
                                <td>Title</td>
                                <td>Description</td>
                                <!-- <td>Properties</td> -->
                                <td>Is Required</td>
                                <td>Action</td>
                              </tr>
                            </thead>
                          
                            <tbody>
                              <tr *ngFor="let property of schema.termProperties ;let k = index">
                                <td class="font1">{{ property.title }}</td>
                                <td class="font1">{{ property.description }}</td>
                                <!-- <td>
                                
                                  <mat-icon style="color:rgb(43, 114, 51)" (click)="showProperties(property)">
                                    visibility
                                  </mat-icon>
                                </td> -->
                                <td>
                                  <input type="checkbox" [checked]="property.properties.required"
                                    (change)="onCheckboxChangemv(i,k)" class="font">
                                </td>
                                <td>
                                  <mat-icon style="color:red" (click)="removeTermmv(i,k)">delete</mat-icon>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </mat-expansion-panel>
                    </mat-card>
                  </div>
                </div>
                <br>
                
                <div class="input-container">
                  <mat-form-field class="input">
                    <mat-label>Has Hierarchy?</mat-label>
                    <mat-select placeholder="" class="font" formControlName="hasHierarchy">
                      <mat-option *ngFor="let item of yesnoarr" [value]="item.code">{{item.value}}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-list"></i> Default</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <form [formGroup]="form">
                  <div formArrayName="expressions">
                    <ng-container *ngFor="let expressionCtrl of expressions?.controls; let i = index">
                      <div [formGroupName]="i">
                        <div class="input-container">
                          <mat-form-field class="input">
                            <mat-select placeholder="Select Type" formControlName="type" class="defaultval">
                              <mat-option value="Literal">Literal</mat-option>
                              <mat-option value="Variable">Variable</mat-option>
                              <mat-option value="Expression">Expression</mat-option>
                            </mat-select>
                            <mat-icon matSuffix color="primary" matTooltip="select type">
                              info
                            </mat-icon>
                          </mat-form-field>
                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Literal'">
                          <div *ngIf="getInputType() !== 'checkbox'">
                            <div class="input-container">
                              <mat-form-field class="input">
                                <mat-label>Constant Value</mat-label>
                                <input matInput [type]="getInputType()" formControlName="const" required>
                              </mat-form-field>
                            </div>
                          </div>
                          <div *ngIf="getInputType() === 'checkbox'">
                            <div class="input-container">
                              <mat-checkbox formControlName="const">Constant Value</mat-checkbox>
                            </div>
                          </div>
                          
                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Variable'">
                          <div class="input-container">
                            <mat-form-field class="input">
                              <mat-label>Variable Name</mat-label>
                              <input matInput formControlName="name" required>
                            </mat-form-field>
                          </div>

                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Expression'">
                          <div class="input-container">
                            <mat-form-field class="input">
                              <mat-label>Select Operator</mat-label>
                              <mat-select formControlName="operator">
                                <mat-option *ngFor="let operator of operators" [value]="operator.code">
                                  {{operator.value}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div formArrayName="operands">
                            <div class="row-container">
                              <h5 class="left-content font" style="margin-left:20% ;"></h5>
                              <button mat-icon-button (click)="addOperand(expressionCtrl)" style="margin-right:20%;">
                                <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Operands
                              </button>
                            </div>
                            <ng-container
                              *ngFor="let operandCtrl of getOperands(expressionCtrl).controls; let j = index">

                              <div [formGroupName]="j" class="stepper-container">
                                <mat-card class="example-card1">
                                  <ng-container [ngTemplateOutlet]="operandTemplate"
                                    [ngTemplateOutletContext]="{ control: operandCtrl }"></ng-container>
                                  <button mat-icon-button color="warn" (click)="deleteOperand(expressionCtrl, j)"
                                    style="position: absolute; top: 10px; right: 10px;">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </mat-card>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                </form>

                <ng-template #operandTemplate let-control="control">
                  <div [formGroup]="control" style="text-align:center ;">
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-select placeholder="Select Type" formControlName="type">
                          <mat-option value="Literal">Literal</mat-option>
                          <mat-option value="Variable">Variable</mat-option>
                          <mat-option value="Expression">Expression</mat-option>
                        </mat-select>
                        <mat-icon matSuffix color="primary" matTooltip="select type">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>

                    <div *ngIf="control.value.type === 'Literal'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Constant Value</mat-label>
                          <input matInput formControlName="const" required>
                        </mat-form-field>
                      </div>
                    </div>

                    <div *ngIf="control.value.type === 'Variable'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Variable Name</mat-label>
                          <input matInput formControlName="name" required>
                        </mat-form-field>
                      </div>

                    </div>

                    <div *ngIf="control.value.type === 'Expression'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Select Operator</mat-label>
                          <mat-select formControlName="operator">
                            <mat-option *ngFor="let operator of operators" [value]="operator.code">{{operator.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div formArrayName="operands">
                        <div class="row-container">
                          <h5 class="left-content font" style="margin-left:20% ;"></h5>
                          <button mat-icon-button (click)="addOperand(control)" style="margin-right:20%;">
                            <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Operands
                          </button>
                        </div>
                        <ng-container *ngFor="let operandCtrl of getOperands(control).controls; let k = index">
                          <div [formGroupName]="k" class="stepper-container">
                            <mat-card class="example-card1">
                              <ng-container [ngTemplateOutlet]="operandTemplate"
                                [ngTemplateOutletContext]="{ control: operandCtrl }"></ng-container>
                              <button mat-icon-button color="warn" (click)="deleteOperand(control, k)"
                                style="position: absolute; top: 10px; right: 10px;">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </mat-card>
                          </div>
                        </ng-container>

                      </div>
                    </div>

                  </div>
                </ng-template>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>

          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-check"></i>Validations</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
              <form [formGroup]="checksform">
                  <div class="row-container">
                    <button mat-icon-button (click)="addValidation()" style="margin-right:20%;">
                      <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Validation
                    </button>

                  </div>
                  <div formArrayName="validations">

                    <ng-container *ngFor="let expressionCtrl of validations.controls; let i = index">
                      <button mat-icon-button color="warn" (click)="removeValidation(i)"
                        style="position: absolute;  right: 10px;">
                        <mat-icon>delete</mat-icon>
                      </button>
                      <div [formGroupName]="i" class="validation-group">

                        <div class="input-container">

                          <mat-form-field class="input">
                            <mat-select placeholder="Select Type" formControlName="type">
                              <!-- <mat-option value="Literal">Literal</mat-option>
                              <mat-option value="Variable">Variable</mat-option> -->
                              <mat-option value="Expression">Expression</mat-option>
                            </mat-select>
                            <mat-icon matSuffix color="primary" matTooltip="select type">info</mat-icon>
                          </mat-form-field>
                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Literal'">
                          <div class="input-container">
                            <mat-form-field class="input">
                              <mat-label>Constant Value</mat-label>
                              <input matInput formControlName="const" required>
                            </mat-form-field>
                          </div>
                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Variable'">
                          <div class="input-container">
                            <mat-form-field class="input">
                              <mat-label>Variable Name</mat-label>
                              <input matInput formControlName="name" required>
                            </mat-form-field>
                          </div>
                        </div>

                        <div *ngIf="expressionCtrl.value.type === 'Expression'">
                          <div class="input-container">
                            <mat-form-field class="input">
                              <mat-label>Select Operator</mat-label>
                              <mat-select formControlName="operator">
                                <mat-option *ngFor="let operator of operatorchecks" [value]="operator.code">
                                  {{ operator.value }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div formArrayName="operands">
                            <div class="row-container">
                              <button mat-icon-button (click)="addOperand(expressionCtrl)" style="margin-left:5%;">
                                <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Operand
                              </button>
                            </div>
                            <ng-container
                              *ngFor="let operandCtrl of getOperands(expressionCtrl).controls; let j = index">
                              <div [formGroupName]="j" class="stepper-container">
                                <mat-card class="example-card1">
                                  <ng-container [ngTemplateOutlet]="operandTemplate"
                                    [ngTemplateOutletContext]="{ control: operandCtrl }"></ng-container>
                                  <button mat-icon-button color="warn" (click)="deleteOperand(expressionCtrl, j)"
                                    style="position: absolute; top: 10px; right: 10px;">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                </mat-card>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                        <!-- <button mat-icon-button color="warn" (click)="removeValidation(i)">
                          <mat-icon>delete</mat-icon> Delete Validation
                        </button> -->
                      </div>
                    </ng-container>
                  </div>

                </form>

                <ng-template #operandTemplate let-control="control">
                  <div [formGroup]="control">
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-select placeholder="Select Type" formControlName="type">
                          <mat-option value="Literal">Literal</mat-option>
                          <mat-option value="Variable">Variable</mat-option>
                          <mat-option value="Expression">Expression</mat-option>
                        </mat-select>
                        <mat-icon matSuffix color="primary" matTooltip="select type">info</mat-icon>
                      </mat-form-field>
                    </div>

                    <div *ngIf="control.value.type === 'Literal'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Constant Value</mat-label>
                          <input matInput formControlName="const" required>
                        </mat-form-field>
                      </div>
                    </div>

                    <div *ngIf="control.value.type === 'Variable'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Variable Name</mat-label>
                          <input matInput formControlName="name" required>
                        </mat-form-field>
                      </div>
                    </div>

                    <div *ngIf="control.value.type === 'Expression'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Select Operator</mat-label>
                          <mat-select formControlName="operator">
                            <mat-option *ngFor="let operator of operatorchecks" [value]="operator.code">
                              {{ operator.value }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div formArrayName="operands">
                        <div class="row-container">
                          <button mat-icon-button (click)="addOperand(control)" style="margin-right:20%;">
                            <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Operand
                          </button>
                        </div>
                        <ng-container *ngFor="let operandCtrl of getOperands(control).controls; let j = index">
                          <div [formGroupName]="j" class="stepper-container">
                            <mat-card class="example-card1">
                              <ng-container [ngTemplateOutlet]="operandTemplate"
                                [ngTemplateOutletContext]="{ control: operandCtrl }"></ng-container>
                              <button mat-icon-button color="warn" (click)="deleteOperand(control, j)"
                                style="position: absolute; top: 10px; right: 10px;">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </mat-card>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-template>


                <ng-template #operandTemplate let-control="control">
                  <div [formGroup]="control" style="text-align:center ;">
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-select placeholder="Select Type" formControlName="type">
                          <mat-option value="Literal">Literal</mat-option>
                          <mat-option value="Variable">Variable</mat-option>
                          <mat-option value="Expression">Expression</mat-option>
                        </mat-select>
                        <mat-icon matSuffix color="primary" matTooltip="select type">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>

                    <div *ngIf="control.value.type === 'Literal'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Constant Value</mat-label>
                          <input matInput formControlName="const" required>
                        </mat-form-field>
                      </div>
                    </div>

                    <div *ngIf="control.value.type === 'Variable'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Variable Name</mat-label>
                          <input matInput formControlName="name" required>
                        </mat-form-field>
                      </div>

                    </div>

                    <div *ngIf="control.value.type === 'Expression'">
                      <div class="input-container">
                        <mat-form-field class="input">
                          <mat-label>Select Operator</mat-label>
                          <mat-select formControlName="operator">
                            <mat-option *ngFor="let operator of operators" [value]="operator.code">{{operator.value}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div formArrayName="operands">
                        <div class="row-container">
                          <h5 class="left-content font" style="margin-left:20% ;"></h5>
                          <button mat-icon-button (click)="addOperand(control)" style="margin-right:20%;">
                            <mat-icon style="color:rgb(0, 119, 128);">add</mat-icon> Add Operands
                          </button>
                        </div>
                        <ng-container *ngFor="let operandCtrl of getOperands(control).controls; let k = index">
                          <div [formGroupName]="k" class="stepper-container">
                            <mat-card class="example-card1">
                              <ng-container [ngTemplateOutlet]="operandTemplate"
                                [ngTemplateOutletContext]="{ control: operandCtrl }"></ng-container>
                              <button mat-icon-button color="warn" (click)="deleteOperand(control, k)"
                                style="position: absolute; top: 10px; right: 10px;">
                                <mat-icon>delete</mat-icon>
                              </button>
                            </mat-card>
                          </div>
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </mat-card>


            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>

              <button mat-button matStepperNext color="primary">Next</button>
            </div>

          </mat-step>
          <mat-step>
            <ng-template matStepLabel><i class="fa fa-comment"></i> Comment</ng-template>
            <div class="stepper-container">
              <mat-card class="example-card1">
                <form [formGroup]="requiredStepForm" class="form-container">
                  <div formGroupName="di_tcd_json">
                    <div class="input-container"    *ngIf="requiredStepForm.get('dt_tcd').value === 'STRING' || requiredStepForm.get('dt_tcd').value === 'JSON'">
                      <mat-form-field class="input">
                        <mat-select placeholder="{{dataObj['charset']['name']}}" formControlName="charset">
                          <mat-option *ngFor="let item of charset" [value]="item.cl_cd">{{item.cl_val}}</mat-option>
                        </mat-select>
                        <mat-icon *ngIf="dataObj['charset']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['charset']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="input-container"  *ngIf="requiredStepForm.get('dt_tcd').value === 'STRING' || requiredStepForm.get('dt_tcd').value === 'JSON'">
                      <mat-form-field class="input">
                        <mat-select placeholder="{{dataObj['collating_seq']['name']}}" formControlName="collating_seq">
                          <mat-option *ngFor="let item of collating_seq" [value]="item.cl_cd">{{item.cl_val}}
                          </mat-option>
                        </mat-select>
                        <mat-icon *ngIf="dataObj['collating_seq']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['collating_seq']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="input-container">
                      <mat-form-field class="input">
                        <mat-label>Is this a Surrogate Term? </mat-label>
                        <mat-select placeholder="" class="font" formControlName="surrogate">
                          <mat-option *ngFor="let item of boolarr" [value]="item">{{item}}</mat-option>
                        </mat-select>
                        <mat-icon *ngIf="dataObj['surrogate']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['surrogate']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>
                    <div class="input-container">
                      <mat-form-field class="input">
                        <textarea matInput placeholder="{{dataObj['comment']['name']}}" formControlName="comment"
                          rows="4"></textarea>
                        <mat-icon *ngIf="dataObj['comment']['description']" matSuffix color="primary"
                          matTooltip="{{dataObj['comment']['description']}}">
                          info
                        </mat-icon>
                      </mat-form-field>
                    </div>
                  </div>

                </form>
              </mat-card>
            </div>
            <div class="button-container">
              <button mat-button matStepperPrevious color="warn">Back</button>
              
              <button mat-button color="primary" *ngIf="rrvconfig['mode']=='create'" (click)="submit()">Submit</button>
              <button mat-button color="primary"  *ngIf="rrvconfig['mode']=='update'" (click)="update()">Update</button>

            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </form>
      <div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

</div>
